import { Component, OnInit } from '@angular/core';
import {Router,ActivatedRoute} from "@angular/router";
import {TranslateService} from "@ngx-translate/core"; 
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { OrderService } from "../../core/services/order.service";
import { UserService } from "../../core/services/user.service";
import {Errors} from "../../core/models";




@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  mobileNumber = ''
  errors = "";
  mobilePattern = "^\\\d{9}$";
  loginForm: FormGroup;
  submitted = false;
  productValue = '';
  mobileNo = '';
  reference = ''; 
  qrcode = '';
  isLoggedin: boolean = false;
  user = null;
  
  isSubmitting = false;
  image = null;

  constructor(
      public translate: TranslateService,
      private router: Router,
      private route: ActivatedRoute,
      private formBuilder: FormBuilder, 
      private orderService: OrderService,
      private userService: UserService,
      
       
  ) {

  }

  ngOnInit(): void {
    this.initForm();
   
   
  }

  isLoggedIn() {

    if (localStorage.getItem('jwtToken')  == null) { 
      this.isLoggedin = false;
      return this.isLoggedin;
    } 
    else {
      this.router.navigateByUrl('merchant/order')
      return true;
    }
  }

  initForm(): void {
    
    this.loginForm = this.formBuilder.group({
      productValue:[this.productValue, [ Validators.required, Validators.pattern("^[0-9.]+$"), Validators.max(999999.99) ] ], 
      mobileNo: [this.mobileNo, Validators.pattern("^((\\+91-?)|0)?[0-9]{9}$")],
      merchantRef: [this.reference],
    });
  }
 

  

  switchLang(lang: string) {
    this.translate.use(lang);
    window.localStorage['lang'] = lang;
  }

  notMyNumber() {
    //this.cleanMyNumber = true;
    this.mobileNumber = ""; 
  }

  onSubmit(): void {
    
  //  this.router.navigate(['merchant/order/qrcode']);
     const tokenValue = window.localStorage.getItem('jwtToken'); 
     this.isSubmitting = false;
     this.image = null;
     this.qrcode = null;
      

     const formData = this.loginForm.value;

    

      
     localStorage.setItem('productValue', this.loginForm.value.productValue);
     localStorage.setItem('storeReference', this.loginForm.value.merchantRef);
    
   

     this.orderService
       .order(formData)
       .subscribe( (data) => { 
         
        const val =  JSON.stringify(data);
       
        localStorage.setItem('qrcode',  data['content'].link ); 

        this.router.navigateByUrl('merchant/order/qrcode')
          
        },
        (err) => { 
 
          if(err['statusCode'] == '500'){ 
             this.isSubmitting = true;
             this.errors = "Sorry, something went wrong" ; 
          };

        }      
       )
  }
 

}
